import { useState } from "react";
import { faqs } from "@/mocks/faqs";
import SchemaMarkup from "@/components/SchemaMarkup";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqSchemaData = {
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <SchemaMarkup type="FAQPage" data={faqSchemaData} />
      <section className="bg-background-100 py-16 md:py-24 px-4 md:px-8 lg:px-12">
        <div className="w-full max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <p className="text-xs uppercase tracking-widest text-foreground-500 mb-3 font-label">
              常见问题
            </p>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
              你可能想知道
            </h2>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left"
                  aria-expanded={openIndex === index}
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-lg text-foreground-500 shrink-0 transition-transform ${
                      openIndex === index ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {openIndex === index && (
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}